import { useItemsFine } from "../_actions/app/items";
import log from "cslog";
import { useState } from "react";
import {
    Card,
    Row,
    Col,
    Spin,
    Empty,
    Typography,
    Badge,
    Flex,
    Space,
} from "antd";
import { MailOutlined, PhoneOutlined } from "@ant-design/icons";
import UserDetailsModal from "./UserDetailsModal";
import QurealSection from "../common/QurealSection";
import SectionHeader from "../components/commons/SectionHeader";
import { UserOutlined } from "@ant-design/icons";
import { blue, green } from "@ant-design/colors";

const { Text, Title } = Typography;

function AllUsers() {
    const {
        data: users,
        isLoading,
        refetch,
    } = useItemsFine(
        "directus_users",
        "fields=id,first_name,last_name,email,mobile,status,user_role,irole,is_dev,last_access,owned_organizations,role.name"
    );

    const [open, setOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);

    log.d(users, "All Users Data");

    if (isLoading) {
        return (
            <Flex
                vertical
                justify="center"
                align="center"
                style={{ minHeight: "400px" }}
                gap="large"
            >
                <Spin size="large" />
                <Title level={4} type="secondary">
                    Loading users...
                </Title>
            </Flex>
        );
    }

    const userList = Array.isArray(users) ? users : users?.data || [];

    const handleCardClick = (user) => {
        setSelectedUser(user);
        setOpen(true);
    };

    return (
        <>
            <QurealSection
                header={
                    <SectionHeader
                        heading="All Users"
                        icon={<UserOutlined />}
                    />
                }
            >
                <div style={{ padding: 28 }}>
                    {userList.length === 0 ? (
                        <Card bordered={false}>
                            <Flex justify="center" align="center">
                                <Empty
                                    description={
                                        <Title level={4}>No users found.</Title>
                                    }
                                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                                />
                            </Flex>
                        </Card>
                    ) : (
                        <Row gutter={[32, 32]}>
                            {userList.map((user) => (
                                <Col
                                    xs={24}
                                    sm={12}
                                    md={8}
                                    lg={6}
                                    key={user.id}
                                >
                                    <Card
                                        hoverable
                                        onClick={() => handleCardClick(user)}
                                        bordered
                                    >
                                        <Space
                                            direction="vertical"
                                            size="large"
                                            style={{ width: "100%" }}
                                        >
                                            <Space
                                                direction="vertical"
                                                size="small"
                                            >
                                                <Badge
                                                    dot
                                                    status={
                                                        user.status === "active"
                                                            ? "success"
                                                            : "default"
                                                    }
                                                    offset={[2, -2]}
                                                >
                                                    <Title
                                                        level={5}
                                                        style={{
                                                            margin: 0,
                                                            paddingRight: 8,
                                                        }}
                                                    >
                                                        {`${
                                                            user.first_name ||
                                                            ""
                                                        } ${
                                                            user.last_name || ""
                                                        }`.trim() || "No Name"}
                                                    </Title>
                                                </Badge>

                                                <Text
                                                    type="secondary"
                                                    ellipsis={{
                                                        tooltip:
                                                            user.role?.name ||
                                                            "No Role",
                                                    }}
                                                >
                                                    {user.role?.name ||
                                                        "No Role"}
                                                </Text>
                                            </Space>

                                            <Space
                                                direction="vertical"
                                                // size="middle"
                                                style={{ width: "100%" }}
                                            >
                                                <Flex
                                                    align="center"
                                                    gap="small"
                                                >
                                                    <MailOutlined
                                                        style={{
                                                            color: blue[5],
                                                        }}
                                                    />
                                                    <Text
                                                        ellipsis
                                                        style={{
                                                            flex: 1,
                                                        }}
                                                    >
                                                        {user.email ||
                                                            "No email"}
                                                    </Text>
                                                </Flex>

                                                <Flex
                                                    align="center"
                                                    gap="small"
                                                >
                                                    <PhoneOutlined
                                                        style={{
                                                            color: green[5],
                                                        }}
                                                    />
                                                    <Text
                                                        ellipsis
                                                        style={{
                                                            flex: 1,
                                                        }}
                                                    >
                                                        {user.mobile ||
                                                            "No phone"}
                                                    </Text>
                                                </Flex>
                                            </Space>
                                        </Space>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    )}

                    {selectedUser && (
                        <UserDetailsModal
                            key={selectedUser.id}
                            open={open}
                            setOpen={setOpen}
                            user={selectedUser}
                            onUserUpdate={refetch}
                        />
                    )}
                </div>
            </QurealSection>
        </>
    );
}

export default AllUsers;
